import { render, staticRenderFns } from "./TopupWalletModal.vue?vue&type=template&id=054cd733"
import script from "./TopupWalletModal.vue?vue&type=script&lang=js"
export * from "./TopupWalletModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports